import { render } from "./CallsReportsTable.vue?vue&type=template&id=78e9fbf6"
import script from "./CallsReportsTable.vue?vue&type=script&lang=js"
export * from "./CallsReportsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__